import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { EditBOUserRPC } from "./editBoUserRPC";

export class EditBOUserRPCClientImpl extends EditBOUserRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: EditBOUserRPC.Request): Promise<LeoRPCResult<EditBOUserRPC.Response, EditBOUserRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "bo-user-management/EditBOUser",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      EditBOUserRPC.ResponseDTO,
      EditBOUserRPC.Errors.ErrorsDTO,
      EditBOUserRPC.Response,
      EditBOUserRPC.Errors.Errors
    >(
      response,
      "bo-user-management/EditBOUser",
      EditBOUserRPC.Response.fromDTO,
      EditBOUserRPC.Errors.fromDTO
    );
  }
}
